import React, { useState, useEffect } from "react";
import {
	Alert,
	AlertIcon,
	AlertTitle,
	AlertDescription,
	Flex,
	VStack,
	Text,
	Box,
	Collapse,
	StackDivider,
	HStack,
	Link,
} from "@chakra-ui/react";
import { SetUpLayout } from "../../Components/Common/SetUpLayout";
import { COLORS } from "../../Helper/Colors";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/Auth/Actions";

const Logout = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { state } = useLocation();
	const [quote, setQuote] = useState(null);
	const [timeLeft, setTimeLeft] = useState(10);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (state?.loggedOut) {
			dispatch(logout());
			if (!isOpen) {
				fetchQuote();
			}
		} else {
			handleNavigate(-1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (timeLeft > 0) {
			setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
		} else {
			handleNavigate("/");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeLeft]);

	const fetchQuote = async () => {
		try {
			const { data } = await axios.get("https://api.quotable.io/random?minLength=50&maxLength=200");
			setQuote(data.content);
			setIsOpen(true);
		} catch (error) {}
	};

	const handleNavigate = (path) => {
		setTimeout(() => window.location.reload(true), 0);
		return navigate(path, { replace: true });
	};

	return (
		<SetUpLayout>
			<Flex height={"100%"} alignItems='center' justifyContent='center' flexDirection={"column"}>
				<Alert
					status='success'
					variant='subtle'
					flexDirection='column'
					alignItems='center'
					justifyContent='center'
					textAlign='center'
					height={"fit-content"}
					maxWidth='550px'
					textTransform={"capitalize"}
					borderRadius={"5px"}
					boxShadow={COLORS.menuBoxShadow}
					paddingY={6}
				>
					<AlertIcon boxSize='40px' mr={0} />
					<AlertTitle my={4} fontSize='2xl'>
						You have successfully logged out.
					</AlertTitle>
					<AlertDescription fontSize='md'>
						<VStack>
							<Text marginBottom={0}>Thank you for visiting justonemoment. Hope to see you soon!</Text>
							<Collapse in={isOpen} animateOpacity>
								<Box maxWidth={"450px"}>
									<Text as='em' fontSize={"sm"} fontWeight={"normal"} color='gray.500' noOfLines={[1, 2, 3]}>
										<Text as='sup' opacity={0.35} textAlign='start' marginRight={1}>
											<FontAwesomeIcon icon={faQuoteLeft} fontSize={"20px"} color={COLORS.brand} />
										</Text>
										{quote}
										<Text as='sub' opacity={0.35} textAlign={"end"} marginLeft={1} bottom={"-0.5em"}>
											<FontAwesomeIcon icon={faQuoteRight} fontSize={"20px"} color={COLORS.brand} />
										</Text>
									</Text>
								</Box>
							</Collapse>
						</VStack>
					</AlertDescription>
				</Alert>
				<HStack
					divider={<StackDivider borderColor='gray.300' />}
					fontSize={"sm"}
					spacing={{ base: 1, md: 4 }}
					paddingX={{ base: 2, md: 0 }}
					marginTop={4}
					align='center'
					justifyContent={"center"}
					textAlign={"center"}
				>
					<Text color='gray.700'>
						Auto redirecting to login page in <span style={{ color: COLORS.brand }}>{timeLeft}secs</span>
					</Text>
					<Link color={COLORS.brand} onClick={() => handleNavigate("/")}>
						Click Here
					</Link>
				</HStack>
			</Flex>
		</SetUpLayout>
	);
};

export default Logout;
